import { getBootstrapModal } from '../bootstrap-runtime';

export function initUsersPreview(root: HTMLElement): void {
    const mailDataUrl = root.dataset.mailDataUrl ?? '';

    if (!mailDataUrl) {
        return;
    }

    $(document).on('click.systemUsersPreview', '.previewMail', function onPreviewMailClick() {
        const itemId = $(this).attr('data-id');

        $.nette.ajax({
            type: 'POST',
            url: mailDataUrl,
            data: { itemId },
            beforeSend() {
                $('#modal-mail-info').html(
                    '<div class="nais-user-page__mail-loading text-center">' +
                        '<div class="loading"></div>' +
                    '</div>',
                );
            },
            done() {
                $('#modal-mail-info').html('');
                const modal = document.getElementById('previewModal');
                if (modal) {
                    getBootstrapModal().getOrCreateInstance(modal).show();
                }
            },
        });
    });
}
